export const BLOC_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 32,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/blocValidationRules.js